"use client";


import Icon from "@/components/ui/AppIcon";

export default function SelfHostedHero() {
  return (
    <section className="pt-32 pb-20 px-6 md:px-8 relative overflow-hidden bg-bg-primary">
      <div className="absolute inset-0 grid-lines opacity-30 pointer-events-none" />
      <div className="absolute top-1/3 right-1/4 w-96 h-96 rounded-full bg-accent-crimson/6 blur-[100px] pointer-events-none" />

      <div className="max-w-container mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 border border-accent-crimson/30 bg-accent-crimson/5 rounded-full px-4 py-1.5 mb-6">
              <Icon name="HomeIcon" size={14} className="text-accent-crimson" />
              <span className="font-mono text-[10px] text-accent-crimson uppercase tracking-widest">
                Self-Hosted Edition
              </span>
            </div>

            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.9] tracking-tight text-white mb-6">
              Your collection.
              <br />
              <span className="italic text-gray-400">Your server.</span>
              <br />
              Your rules.
            </h1>

            <p className="text-gray-400 text-base leading-relaxed max-w-lg border-l border-accent-crimson/40 pl-5 mb-8">
              Run TapTale entirely on your own hardware. A Raspberry Pi 4 is all you need to host a museum-grade collection catalog with complete data sovereignty — no monthly fees, no third-party access, no compromises. Note: Self-hosted users need to purchase and program NFC tags independently.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#setup"
                className="btn-lift inline-flex items-center justify-center gap-2 bg-accent-crimson hover:bg-accent-crimson-hover text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-colors"
              >
                <Icon name="RocketLaunchIcon" size={16} />
                <span>Start Setup Guide</span>
              </a>
              <a
                href="#architecture"
                className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-white/30 text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-all duration-300 hover:bg-white/5"
              >
                <Icon name="CpuChipIcon" size={16} />
                <span>View Architecture</span>
              </a>
            </div>
          </div>

          {/* Stats / Highlights */}
          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-4">
              {[
                {
                  icon: "ShieldCheckIcon",
                  label: "Data Sovereignty",
                  desc: "Your data never leaves your network",
                  color: "text-accent-emerald",
                  glow: "bg-accent-emerald/10",
                },
                {
                  icon: "CurrencyDollarIcon",
                  label: "No Monthly Fees",
                  desc: "One-time hardware cost only",
                  color: "text-accent-gold",
                  glow: "bg-accent-gold/10",
                },
                {
                  icon: "CpuChipIcon",
                  label: "Raspberry Pi Ready",
                  desc: "Runs on modest hardware",
                  color: "text-accent-purple",
                  glow: "bg-accent-purple/10",
                },
                {
                  icon: "CodeBracketIcon",
                  label: "Open Source",
                  desc: "Full source code access",
                  color: "text-accent-cyan",
                  glow: "bg-accent-cyan/10",
                },
              ].map((item) => (
                <div
                  key={item.label}
                  className="rounded-2xl border border-white/5 bg-bg-card p-5 card-hover"
                >
                  <div className={`w-10 h-10 rounded-xl ${item.glow} border border-white/10 flex items-center justify-center mb-4`}>
                    <Icon name={item.icon as any} size={18} className={item.color} />
                  </div>
                  <p className="text-white text-sm font-medium mb-1">{item.label}</p>
                  <p className="text-gray-600 text-xs leading-snug">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}